interface WindowWithApplePaySession extends Window {
  ApplePaySession?: typeof ApplePaySession;
}

export const ApplePaySessionClass =
  typeof window !== "undefined"
    ? (window as WindowWithApplePaySession).ApplePaySession
    : undefined;
